import React from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    url: '/news',
    external: false,
    name: 'News',
  },
  {
    url: 'https://shop.bloodybattle.net/',
    external: true,
    name: 'Boutique',
  },
  {
    url: '/',
    external: false,
    isLogo: true,
  },
  {
    url: '/jouer',
    external: false,
    name: 'Jouer',
  },
  {
    url: 'https://discord.gg/YC4XPGp',
    external: true,
    name: 'Discord',
  },
];

const logoItem = (url, i) => (
  <li key={i}>
    <Link to={url}>
      <img
        id="logo"
        src="./BloodyBattle-logo.png"
        alt="BloodyBattle"
      />
    </Link>
  </li>
);

const linkItem = (section, i) => (
  <li key={i}>
    {section.external
      ? (<a href={section.url} className="menuItem">{section.name}</a>)
      : (<Link to={section.url} className="menuItem">{section.name}</Link>)}
  </li>
);

const Menu = () => (
  <nav>
    <ul>
      {sections.map((section, i) => (section.isLogo
        ? logoItem(section.url, i)
        : linkItem(section, i)))}
    </ul>
  </nav>
);

export default Menu;



// WEBPACK FOOTER //
// ./src/layout/Menu.js